import _ from "lodash";
/** -- external -- */
import React from "react";
import { connect } from "react-redux";

/** -- internal -- */
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import { getUserCoursesFromCache } from "Teacher/modules/TeacherGraphqlHelpers";
import { getCourseFiltersMemoize } from "Teacher/modules/TeacherModule";
import { selectedAcademicYearSelector } from "Platform/modules/PlatformModule";
import { localSearch } from "Utils";
import { getCurrentCurriculumContextForJumpTo } from "modules/CommonSelectors";

const CourseFeedWrapperForFreeProgram = ({
  children,
  data,
  courseGradeFilters,
}) => {
  return children({
    data,
    hasNextPage: false,
    loadMoreFeed: _.noop,
    networkStatus: 7,
    courseGradeFilters,
  });
};

const mapStateToProps = (state, { searchText }) => {
  const userInfo = getUserInfo();

  const { id: userId, userEntityType } = userInfo;

  const organizationCurriculumPrograms =
    state.platform.organizationCurriculumPrograms;

  const selectedAcademicYear = selectedAcademicYearSelector(state);

  const {
    isCurrentAcademicYear = true,
    id: academicYear = "",
  } = selectedAcademicYear;

  const {
    id: currentCurriculumProgramId,
  } = getCurrentCurriculumContextForJumpTo(state);

  const userTags = userInfo.tags || [];
  const user_type = userInfo.user_type;

  const courseFilters = getCourseFiltersMemoize({
    currentCurriculumProgramId,
    organizationCurriculumPrograms,
    isCurrentAcademicYear,
    academicYear,
    userTags,
    user_type,
  });

  const courseGradeFilters = { academicYearId: academicYear };

  const queryData = getUserCoursesFromCache({
    id: userId,
    type: userEntityType,
    filters: courseFilters,
    courseGradeFilters,
    isCurriculumProgramFree: true,
  });

  const allCourses = _.map(
    _.filter(
      _.get(queryData, "courses", []),
      course =>
        course.isDemo === false &&
        localSearch({ searchText, text: course.title }) > -1
    ),
    course => ({ node: course })
  );

  return {
    data: allCourses,
    courseGradeFilters,
  };
};

export default connect(mapStateToProps)(CourseFeedWrapperForFreeProgram);
